import { FileIcon } from 'lucide-react';

export const QuoteIcon = FileIcon;
